// extracted by mini-css-extract-plugin
export var alpha = "_8v-4";
export var alphaInputContainer = "_8v-f";
export var badge = "_8v-b";
export var brandKitGrid = "_8v-h";
export var brandKitItem = "_8v-i";
export var brandKitSwatch = "_8v-j";
export var controls = "_8v-5";
export var formatDropdown = "_8v-d";
export var formatSelector = "_8v-c";
export var hex = "_8v-6";
export var hexInput = "_8v-e";
export var hue = "_8v-3";
export var hueAndAlphaPointer = "_8v-a";
export var percentageLabel = "_8v-g";
export var picker = "_8v-0";
export var rgba = "_8v-8";
export var rgbaSection = "_8v-7";
export var saturation = "_8v-1";
export var saturationPointer = "_8v-9";
export var sliders = "_8v-2";